import { render } from "./HeroAuthProfile.vue?vue&type=template&id=27a353a1&scoped=true"
import script from "./HeroAuthProfile.vue?vue&type=script&lang=js"
export * from "./HeroAuthProfile.vue?vue&type=script&lang=js"

import "./HeroAuthProfile.vue?vue&type=style&index=0&id=27a353a1&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a353a1"]])

export default __exports__